"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Services = _interopRequireDefault(require("../Services"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hourglass = function Hourglass(props) {
  return _react.default.createElement("div", {
    className: "sl-hourglass"
  }, _react.default.createElement("div", {
    className: "sl-hourglass-loader-items",
    style: {
      "--size": _Services.default.getZoom(props.size || 100)
    }
  }, _react.default.createElement("div", {
    className: "sl-hourglass-item",
    style: {
      "--bg": props.bgColor || "#FFFFFF"
    }
  })), props.title !== undefined ? _react.default.createElement("div", {
    className: "sl-hourglass-loader-title",
    style: {
      "--cl": props.color || "#FFFFFF"
    }
  }, _react.default.createElement("span", null, props.title)) : null);
};

var _default = Hourglass;
exports.default = _default;